import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';

import { AppStateInterface } from 'app/core/app-config/state/models/app-state.interface';
import { LoadLanguages } from 'app/core/language/state/actions';

import { LanguageServiceInterface } from './language-service.interface';

@Injectable()
export class LanguageService implements LanguageServiceInterface {

  constructor(private readonly _store: Store<AppStateInterface>) {}

  public getLanguages(): Observable<Readonly<{[key: string]: string}>> {
    this._store.dispatch(new LoadLanguages());

    return this._store.select(({ language }: AppStateInterface) => language);
  }
}
